import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {TabReportModel} from "./tab-report.model";

@Component({
    selector: "wbo-tab-report",
    templateUrl: "./tab-report.component.html",
    providers: [provideReportModel(TabReportModel)]
})
export class TabReportComponent extends AbstractReportPage {
    constructor(public model: TabReportModel) {
        super();
    }

}
